import React from 'react';
import InvalidFeedback from './invalid-feedback.component';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/forms/icon.component';

export default React.forwardRef(
  (
    {
      type = 'text',
      optional = false,
      label,
      page = '',
      placeholder,
      typeBg = '',
      uniqueTheme = false,
      requiredIndicator = '',
      errors,
      currentLength,
      maxLength,
      children,
      sizeClass = 'form-control-lg',
      ...register
    }: any,
    ref
  ) => {
    const { t } = useTranslation();

    return (
      <>
        <div data-kt-password-meter={type === 'password' ? 'true' : 'undefined'}>
          <div className="mb-1">
            {label && (
              <label htmlFor={label} className={`form-label ${requiredIndicator} ${typeBg}`}>
                {label}{' '}
                {optional && (
                  <span className="fs-8 text-muted ms-1">({t('general.optional')})</span>
                )}
              </label>
            )}
            <div className={'d-flex ' + (errors ? 'is-invalid' : '')}>
              <input
                type={type}
                id={label}
                ref={ref}
                autoComplete="new-password"
                name="new-password-field"
                placeholder={placeholder}
                className={
                  `${uniqueTheme ? 'form-controlb form-control-solidb ' : 'form-control form-control-solid '}` +
                  sizeClass +
                  (errors ? ' is-invalid ' : '')
                }
                {...register}
              />
              {children}

              {type === 'password' && (
                <div className={'position-relative mb-0' + (errors ? ' d-nones ' : '')}>
                  <span
                    className={`btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2`}
                    data-kt-password-meter-control="visibility"
                  >
                    <Icon
                      icon="ki-eye-slash"
                      size="fs-1"
                      type={`${page === 'login' ? 'white' : 'dark'}`}
                      className={`${errors ? 'me-10' : ''}`}
                    />
                    <Icon
                      icon="ki-eye"
                      size="fs-1"
                      type={`${page === 'login' ? 'white' : 'dark'}`}
                      className={`${errors ? 'me-10' : ''} d-none`}
                    />
                  </span>
                </div>
              )}
            </div>

            <InvalidFeedback error={errors} />

            {maxLength && maxLength > 0 && (
              <div className="form-text mt-1 text-end">
                {currentLength}/{maxLength}
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
);
